<template>
  <section id="content" v-if="page">
    <div class="inner" v-html="page.main_text"></div>
    <div class="split">
      <template v-for="image in page.images">
        <a
          v-if="image.url.includes('youtu') == false"
          :key="image._id"
          :href="image.url"
          :target="image.url.includes('funeralzone') ? '_blank' : ''"
          :rel="image.url.includes('funeralzone') ? 'noreferrer' : ''"
        >
          <img :alt="image.alt" :src="image.image" />
        </a>
        <a v-else @click.prevent="showModal = true" :key="image._id">
          <img :alt="image.alt" :src="image.image" />
          <base-modal
            v-if="image.url.includes('youtu')"
            :show="showModal"
            @close="showModal = false"
          >
            <div class="embed-container">
              <iframe :src="image.url" frameborder="0" allowfullscreen></iframe>
            </div>
          </base-modal>
        </a>
      </template>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex"
import { fchown } from "fs"

export default {
  data: function() {
    return {
      showModal: false
    }
  },
  computed: {
    ...mapState(["page"])
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.embed-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  max-width: 100%;
}
.embed-container iframe,
.embed-container object,
.embed-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

section {
  text-align: center;
  padding-top: 4rem;
  padding-bottom: 1rem;
  line-height: 1.8;
  font-size: 1.8rem;
}

p {
  max-width: 1000px;
  margin: auto;
}

.large {
  font-size: 2rem;
}

.split {
  margin-top: 8rem;
  line-height: 0;
  text-align: center;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
  width: 100%;
  grid-gap: 1rem;
}

.split a {
  overflow: hidden;
}

.split img {
  width: 100%;
  transition: all 0.4s ease-in-out;
}

.split a:hover img {
  transform: scale(1.02);
  filter: brightness(1.15);
}

.split a:nth-child(1) {
  grid-column: 1 / 3;
}

.split a:nth-child(2) {
  grid-column: 3 / 5;
}

.split a:nth-child(3) {
  grid-column: 5 / 7;
}

.split a:nth-child(4) {
  grid-column: 1 / 4;
}

.split a:nth-child(5) {
  grid-column: 4 / 7;
}

@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .split {
    display: table;
    width: 100%;
  }

  .split a {
    display: block;
    float: left;
    outline: 10px solid white;
  }

  .split:hover a img {
    transform: none;
  }

  .split a:nth-child(1) {
    width: 33%;
  }

  .split a:nth-child(2) {
    width: 67%;
  }

  .split a:nth-child(4) {
    width: 33%;
  }

  .split a:nth-child(3) {
    width: 67%;
  }

  .split a:nth-child(5) {
    width: 50%;
  }

  .split a:nth-child(6) {
    width: 50%;
  }
}

@media screen and (max-width: 750px) {
  .split {
    grid-template-columns: 1fr;
  }
  .split a {
    grid-column: 1 / 2 !important;
  }
}
</style>
